import { render, staticRenderFns } from "./modifyImg.vue?vue&type=template&id=10521a55&scoped=true"
import script from "./modifyImg.vue?vue&type=script&lang=js"
export * from "./modifyImg.vue?vue&type=script&lang=js"
import style0 from "./modifyImg.vue?vue&type=style&index=0&id=10521a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10521a55",
  null
  
)

export default component.exports